import { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { StateContextProvider } from './services/context';
import { tabs, getFirstGroupData, selectedContentType, DocumentData } from './utils/state';
import { api } from './services/POST';
import { useTheme } from './utils/themeUtils';
import { classNames } from './utils/utils';
import { PopupModal, PopupIconOptionsType, PopupMessageType } from './Components/Modals/PopupModal';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';


function App() {
  const navigate = useNavigate();

  const [user, setUser] : [any, any] = useState({shopname: "", email: "", plan: "", timeout: ""});
  async function get_auth_data() {
    try{
      const data_user = await api("/get_data_by_shopname")
      setUser({shopname: data_user.shopname, email: data_user.email, plan: data_user.plan, timeout: data_user.timeout})
    } catch {
      setUser({shopname: "", email: "", plan: "", timeout: ""})
      console.log("error")
    }
  }
  useEffect(() => {
    get_auth_data()
    const params = new URLSearchParams(window.location.search);
    const done = params.get('done')
    if (done === 'failed') {navigate('/failed')}
    if(done === 'success') { navigate('/success')}
  }, []);


  

  const [contentType, setContentType] = useState<selectedContentType>({group: tabs[0].componentName, content: getFirstGroupData(tabs[0].groupData)})
  const [loadedDocument, setLoadedDocument] = useState<DocumentData>({id: '', name: '', data: '', date: ''})
  const { themeString } = useTheme()

  
  const [popupMessage, setPopupMessage] = useState<PopupMessageType>({id: "", text: "", iconOption: null})
  const popupMessageActualId = useRef("");
  const showPopup = (message: string, iconOption: PopupIconOptionsType) => {
    let id = uuidv4();
    setPopupMessage({id: id, text: message, iconOption: iconOption})
    popupMessageActualId.current = id;
    setTimeout(() => { if (popupMessageActualId.current === id) setPopupMessage({id: "", text: "", iconOption: null}) }
    , 3000);
  };


  
  if (user?.shopname !== "") {
    return (
      <StateContextProvider value={{
        user: user, load: get_auth_data, 
        contentType: contentType, setContentType: setContentType,
        loadedDocument: loadedDocument, setLoadedDocument: setLoadedDocument,
        showPopup: showPopup
      }}>
        <div className={classNames('flex h-screen w-full no-scrollbar', themeString)}>
          <Outlet/>
          <PopupModal popupMessage={popupMessage} closePopup={() => setPopupMessage({id: "", text: "", iconOption: null})} />
        </div>
      </StateContextProvider>
    );
  }

  return (
    <div className="flex h-full items-center justify-center">
      Loading...
    </div>
  )


}

export default App;




